<!--
  StatusBadge Component
  Processing pipeline status indicator with i18n support.
-->
<script lang="ts">
  import { _ } from 'svelte-i18n';

  export let status: string;

  const variantMap: Record<string, string> = {
    uploading: 'bg-info/15 text-info border-info/30',
    uploaded: 'bg-info/15 text-info border-info/30',
    pending: 'bg-info/15 text-info border-info/30',
    processing: 'bg-warning/15 text-warning border-warning/30',
    ocr: 'bg-warning/15 text-warning border-warning/30',
    'ocr-processing': 'bg-warning/15 text-warning border-warning/30',
    classifying: 'bg-warning/15 text-warning border-warning/30',
    extracting: 'bg-warning/15 text-warning border-warning/30',
    // Keep the green statuses in sync with FINISHED_STATUSES (documentStatus.ts).
    completed: 'bg-success/15 text-success border-success/30',
    finished: 'bg-success/15 text-success border-success/30',
    processed: 'bg-success/15 text-success border-success/30',
    failed: 'bg-error/15 text-error border-error/30',
    error: 'bg-error/15 text-error border-error/30',
    'manual-review': 'bg-warning/15 text-warning border-warning/30',
  };

  const pulseStatuses = new Set([
    'processing',
    'ocr',
    'ocr-processing',
    'classifying',
    'extracting',
  ]);

  $: key = status?.toLowerCase() ?? '';
  $: variant = variantMap[key] || 'bg-surface-hover text-text-secondary border-border';
  $: label = $_(`document_status.${key}`, { default: status });
  $: isPulsing = pulseStatuses.has(key);
</script>

<span
  class="inline-flex items-center gap-1.5 px-2 h-6 text-xs font-medium rounded-full border {variant}"
>
  <span class="w-1.5 h-1.5 rounded-full bg-current {isPulsing ? 'animate-pulse' : ''}"></span>
  {label}
</span>
